import React from 'react';
import './PlaylistQuestions.styl';
import ArrowButton from 'components/pure/utils/ArrowButton';
import {browserHistory} from 'react-router';
import {RepProfileTab} from '@store/coaching-plans';

/**
 * A button that appears in the playlist when recipients (and only recipients -- not coaches)
 * have unanswered questions.
 */
export default class PlaylistQuestions extends React.PureComponent {
  render() {
    const {rep, review, reviewType, sessionUser, todo} = this.props;
    if (!rep || !review || !todo) {
      return null;
    }

    if (sessionUser.id !== rep.id) {
      // We only have questions as todos for recipients.
      return null;
    }

    const hasRepQuestions =
      reviewType && reviewType.questions.filter(question => question.respondent === 'REP').size > 0;

    if (!hasRepQuestions) {
      // Review type has no questions for the rep. Nothing to show them.
      return null;
    }

    const hasUnansweredRequiredQuestions = todo.requiredUnansweredQuestions > 0;
    const hasUnansweredOptionalQuestions = todo.optionalUnansweredQuestions > 0;

    const className =
      hasUnansweredRequiredQuestions || hasUnansweredOptionalQuestions ? 'incomplete' : 'complete';
    const questionPhrase = hasUnansweredRequiredQuestions
      ? todo.questionPhrase(true)
      : // can still go back to edit, or answer any unanswered optional questions.
        'Answer review questions';

    return (
      <div className="playlist-questions" onClick={() => goToReview(rep, review)}>
        <div className="playlist-question-heading">Answer Review Questions</div>
        <div className="playlist-question-body">
          <div className={className}>{questionPhrase}</div>
          <div className="arrow-button-wrapper">
            <ArrowButton />
          </div>
        </div>
      </div>
    );
  }
}

/** Go to the recipient's view of the review, autostart and in edit mode. */
function goToReview(rep, review) {
  browserHistory.push({
    pathname: '/metrics/profile',
    query: {
      tab: RepProfileTab.COACHING_PLANS,
      // review.rep is not defined here for whatever reason.
      teamId: rep.teamId,
      userId: rep.id,
      planId: review.planId,
      reviewId: review.id,
      autoStartReview: true,
    },
  });
}
